import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./scss/seller-requisites.scss";
import Icon from "../lib/icon";
import api from "../api";
import Button from "../components/Button";
import { useToast } from "../contexts/ToastContext";
import ManagerFooter from "../components/ManagerFooter";

export default function SellerRequisitesPage() {
  const navigate = useNavigate();
  const { showToast } = useToast();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  async function load() {
    try {
      const { data } = await api.get("/api/seller/profile/requisites");
      setData(data);
    } catch {
      navigate("/seller");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
  }, []);

  if (loading) return null;
  if (!data) return null;

  function handleEditClick() {
    showToast("Для изменения реквизитов свяжитесь с менеджером", "info");
  }

  return (
    <>
    <div className="seller-requisites">

      {/* HEADER */}
      <div className="seller-requisites__header">
        <button
          className="seller-requisites__back"
          onClick={() => navigate(-1)}
        >
          <Icon name="arrow-left" />
          Назад
        </button>
      </div>

      <div className="seller-requisites__breadcrumbs">
        Главная <span>›</span> Реквизиты
      </div>

      <h1 className="seller-requisites__title">
        Реквизиты для вывода
      </h1>

      <div className="seller-requisites__block">
        <div className="seller-requisites__label">
          Название банка
        </div>
        <div className="seller-requisites__value">
          {data.nameBank}
        </div>
      </div>

      <div className="seller-requisites__block">
        <div className="seller-requisites__label">
          Расчетный счет
        </div>
        <div className="seller-requisites__value">
          {data.settlementAccount}
        </div>
      </div>

      <div className="seller-requisites__block">
        <div className="seller-requisites__label">
          БИК
        </div>
        <div className="seller-requisites__value">
          {data.bikAccount}
        </div>
      </div>

      <div className="seller-requisites__block">
        <div className="seller-requisites__label">
          Корреспондентский счет
        </div>
        <div className="seller-requisites__value">
          {data.correspondentAccount}
        </div>
      </div>

      <Button
        className="btn-primary large seller-requisites__button"
        onClick={handleEditClick}
      >
        Изменить реквизиты
      </Button>
      
    </div>
    <ManagerFooter />
    </>
  );
}
